import { downloadFileInSameTab } from './file/downloadFileInSameTab';

export async function htmlToImgAsync(el: HTMLElement, options?: Record<string, unknown>) {
  const { toPng } = await import('html-to-image');
  const dataUrl = await toPng(el, options);
  if (!dataUrl) throw new Error('Failed to capture image');
  downloadFileInSameTab(dataUrl, 'captured-image.png');
}

export function htmlToImg(el: HTMLElement, options?: Record<string, unknown>) {
  try {
    void htmlToImgAsync(el, options);
  } catch (error) {
    console.error(error);
  }
}

export async function htmlToImgUrl(
  el: HTMLElement,
  options?: Record<string, unknown>,
): Promise<string> {
  try {
    const { toPng } = await import('html-to-image');
    const dataUrl = await toPng(el, options);
    return dataUrl;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
